import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function Button({
  label,
  onClick = () => {},
  disabled = false,
  className = '',
  transparent = false,
  fullWidth = false,
  type = 'primary',
  size = 'default',
  icon,
}) {
  return (
    <button
      className={classNames(`btn btn--${type} btn--${size}`, {
        [className]: className,
        'btn--full-width': fullWidth,
        transparent,
      })}
      onClick={(e) => onClick(e)}
      disabled={disabled}
      type="button"
    >
      {icon}
      {label}
    </button>
  );
}

Button.propTypes = {
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  transparent: PropTypes.bool,
  type: PropTypes.oneOf([
    'primary',
    'secondary',
    'tertiary',
    'ghost'
  ]),
  size: PropTypes.oneOf([
    'big',
    'large',
    'default',
    'small'
  ]),
  fullWidth: PropTypes.bool
};
